import styled from 'styled-components'

export const ImageEvent = styled.img.attrs({
  className: 'img-responsive s-rounded',
})`
  max-width: 150px;
  transition: all .2s ease-in-out;

  :hover {
    transform: scale(1.02);
    box-shadow: 0 0.25rem 1rem rgba(48,55,66,.2);
  }
`
